<!--
  Se opta por dar soporte de descuentos unicamente a la susc
-->
<template>
  <b-row>
    <b-col lg="4">
      <label>{{ label }}</label>
    </b-col>
    <b-col lg="8">
      <b-form-select :value="value" :options="comboDescuento" @input="onInput" :disabled="disabled" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tiposDescuento: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    comboDescuento() {
      return this.tiposDescuento.map((x) => {
        return {
          value: x.descuento,
          text: x.descripcion,
        };
      });
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>
